const CABINET_API_HOST = window.cabinetApiEndpoint;

const handleCredentialResponse = (credentialResponse) => {
  const xhr = new XMLHttpRequest();
  xhr.open('POST', `${CABINET_API_HOST}/user/auth/google`, true);
  xhr.setRequestHeader('Content-type', 'application/json');
  xhr.withCredentials = true;
  xhr.addEventListener('load', () => {
    const response = JSON.parse(xhr.responseText);
    if (response.status !== 'ok' || response.data === 0) return;
    window.location.reload();
  });
  xhr.send(JSON.stringify({ token: credentialResponse.credential }));
};

const oneTapLogin = () => {
  if (!window.isGuest) return;
  try {
    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.onload = () => {
      if (!window.google && !window.google.accounts) return;
      window.google.accounts.id.initialize({
        client_id: window.googleClientId,
        callback: handleCredentialResponse,
      });
      window.google.accounts.id.prompt();
    };
    document.body.appendChild(script);
    // eslint-disable-next-line no-empty
  } catch (err) {}
};

export default oneTapLogin;
